window.__tnt || (window.__tnt = {});
window.addEventListener('tnt-dmp-behavior-rec', function(e) {
    let audiences = e.detail.userAudience, // from the event
        keywords = getMeta('keywords'),
        containers = document.querySelectorAll('.tnt-recommendations');
    
    // Return if nothing to work with
    if (containers.length <= 0) return;
    if (typeof(audiences) == 'undefined' && keywords == null) return;
    
    // Scrub audiences for use 
    if (typeof(audiences) !== 'undefined' && audiences.length > 0) {
        for(var i = 0; i < audiences.length; i++) {
            audiences[i] = audiences[i].replace('keyword:', '');
        }
        // Make audiences usable in search
        audiences = encodeURIComponent(audiences.join(','));
    } 
    
    // Observer callback
    let callback = function(entries, io) { 
        entries.forEach(function(entry) {
            if (entry.isIntersecting === true) {
                // Remove observer from this entry
                io.unobserve(entry.target);
                
                // Fetch assets with audiences
                if (entry.target.dataset.query != 'context' && audiences) { 
                    fetchAssets(entry.target, audiences);
                }
                
                // Fetch assets with keywords
                if (entry.target.dataset.populated != 'true'
                    && (entry.target.dataset.query == 'context' || entry.target.dataset.query == 'behave_context')) {
                    fetchAssets(entry.target, keywords);
                }
            }
        });
    };
    
    // Config and create observer
    let io_config = { rootMargin: '0px 0px 500px' },
        io = new IntersectionObserver(callback, io_config);
    
    // Observe all containers (.tnt-recommendations)
    for (var i = 0; i < containers.length; i++) {
         if (typeof(audiences) == 'undefined' && containers[i].dataset.query == 'behavioral') {
             containers[i].parentNode.removeChild(containers[i]); 
         } else {
            io.observe(containers[i]);
         }
    }
    
    // Fetch assets
    function fetchAssets(container, keywords) {
        // Return if container is populated
        if (container.dataset.populated == 'true') return;
        
        let preview = container.dataset.preview,
            searchUrl = '/tncms/search/recommend/?app=editorial&t=article&inline=summary&preview=' + preview + '&k=' + keywords;
        
        fetch(searchUrl)
            .then(function(response) {
                if (response.status !== 200) {
                    __tnt.log('Error. Status Code: ' + response.status);
                    return;
                }
            // Examine response
            response.json()
                .then(function(data) {
                    // If no assets return
                    if (data.assets === undefined || data.assets.length == 0) return; 
                    
                    // Container has assets
                    container.dataset.populated = 'true';
                    
                    let html = '',
                        assets = __tnt.shuffleArray(data.assets);
                    
                    // Build HTML content
                    for (let i = 0, j = 0; i < assets.length; i++) {
                        if (j >= container.dataset.max) break;
                        // Ensure default inline content is not displayed
                        if (assets[i].content.includes('tncms-inline-asset') == false) {
                            html += assets[i].content;
                            j++;
                        }
                    }
                    
                    // Add Lotame pixel
                    if (typeof(container.dataset.lotameTrack) != 'undefined') {
                        html += '<img src="https://bcp.crwdcntrl.net/5/c=9613/b=37454954" width="1" height="1" class="hidden" />';
                    }
                    
                    // Add IQ pixel
                    if (typeof(container.dataset.iqTrack) != 'undefined') {
                        html += '<img src="https://bcp.crwdcntrl.net/5/c=9613/b=' + container.dataset.iqTrack + '" width="1" height="1" class="hidden" />';
                    }
                    
                    // Place HTML in target container
                    container.innerHTML = html;
            });
        })
        .catch(function(err) {
            __tnt.log('Fetch Error: ', err);
        });
    }
    
    // Gather keywords from meta
    function getMeta(metaName) {
        const metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') === metaName) {
                return metas[i].getAttribute('content');
            }
        }
        return '';
    }
});